import * as React from 'react';
import { LoyaltyPointsEducation } from 'models/common/loyalty-education';
import { LoyaltyEducationSectionContent } from './loyalty-education-section-content';

interface LoyaltyPointsEducationContentProps {
  content: LoyaltyPointsEducation;
}

export const LoyaltyPointsEducationContent: React.FunctionComponent<LoyaltyPointsEducationContentProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    <React.Fragment>
      <p className="uitk-type-paragraph-300 all-b-margin-three">{content.description}</p>
      {content.programFeatures.map(features => (
        <LoyaltyEducationSectionContent key={features.toString()} {...features} />
      ))}
    </React.Fragment>
  );
};
LoyaltyPointsEducationContent['displayName'] = 'LoyaltyPointsEducationContent';
